const state = {
  trackingList: [],
  excessMaterials: null,
  isExcessMaterialLoading: false,
  // POD Bulk Upload state
  activePodBulkUpload: null,
  podBulkUploadId: null,
  podBulkUploadData: null,
  podBulkStatus: null,
  podBulkStatusData: null,
};

export default state;
